import config from "../../boot/config";
import http from "../../boot/http.js";
import moment from "moment";
import { sha512 } from "../../libs/js-sha512";
import { DateTime } from "../../utils";
import dateTime from "../../utils/dateTime";

const route = "security/";
const baseRoute = config.ibmsBaseUrl.replace('\r', '');

export default class SecurityService {

	static loginAD(token) {
		if(!token) {
			return Promise.resolve({ error: "Token empty" });
		}
		let url = `${baseRoute}home/getjwt`;
		return http({ url, method: "GET", headers: { 'Authorization': `Bearer ${token}`} }, { responseType: 'json' })
			.then(data => data)
			.catch(error => error);
	}
   static login(username, password) {
      if (!username || !password) {
         throw { error: "Username or password empty" };
      }

      let url = `${baseRoute}home/getjwt`;
      //hash 4 ibms
      password = sha512(password);

      return http({ url, method: "GET", username, password })
         .then(data => data)
         .catch(error => error);

      /*  return http({
            url, method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            data: `grant_type=password&password=${password}&username=${username}`
        })
            .then((data) => {
                if (data instanceof Error) {
                    return Error(`Username or password incorrect`);
                }
                else {
                    //we winnah
                    return data;
                }
            })
            .catch((error) => error)*/
   }

   static getDetails() {
      let url = `${config.baseUrl + route}GetDetails`;

      return http({ url, method: "GET" })
         .then(data => data)
         .catch(error => error);
   }

   static ResetPassword(userName) {
      let url = `${config.baseUrl + route}ResetPassword`;

      return http({ url, method: "GET", userName })
         .then(data => data)
         .catch(error => error);
   }

   static ChangePassword(data) {
      let url = `${config.baseUrl + route}ChangePassword`;

      return http({ url, method: "POST", data })
         .then(data => data)
         .catch(error => error);
   }

   static createUser(user) {
      let url = `${config.baseUrl + route}Register`;

      const data = { ...user, phoneNumber: user.phone, confirmPassword: user.password };

      return http({ url, method: "POST", data })
         .then(data => data)
         .catch(error => error);
   }

   static checkUserName(username) {
      let url = `${config.baseUrl + route}checkUserName`;

      return http({ url, method: "GET", username })
         .then(data => data)
         .catch(error => error);
   }

   // static registerForPushNotifications() {
   //     try {
   //         PushNotificationIOS.addEventListener('registrationError', s => console.log("PushError", s))
   //         PushNotification.configure({

   //             // (optional) Called when Token is generated (iOS and Android)
   //             onRegister: function (token) {
   //                 let url = `${config.baseUrl + route}storePushNotiToken`;
   //                 token.platform = token.os;
   //                 // POST the token to your backend server from where you can retrieve it to send push notifications.
   //                 return http({ url, method: 'POST', data: token })
   //                     .then((data) => data)
   //                     .catch((error) => error)
   //             },

   //             // (required) Called when a remote or local notification is opened or received
   //             onNotification: function (notification) {
   //                 console.log('NOTIFICATION:', notification);

   //                 ablyservice.handleIncomimgPushNotification(notification);

   //                 // required on iOS only (see fetchCompletionHandler docs: https://facebook.github.io/react-native/docs/pushnotificationios.html)
   //                 notification.finish(PushNotificationIOS.FetchResult.NoData);
   //             },

   //             // ANDROID ONLY: GCM Sender ID (optional - not required for local notifications, but is need to receive remote push notifications)
   //             // Your GCM senderID can be obtained by obtaining a file from your google console called google-services.json. From this file use the project_number as your ID.
   //             senderID: gservices.project_info.project_number,

   //             // IOS ONLY (optional): default: all - Permissions to register.
   //             permissions: {
   //                 alert: true,
   //                 badge: true,
   //                 sound: true
   //             },

   //             // Should the initial notification be popped automatically
   //             // default: true
   //             popInitialNotification: true,

   //             /**
   //               * (optional) default: true
   //               * - Specified if permissions (ios) and token (android and ios) will requested or not,
   //               * - if not, you must call PushNotificationsHandler.requestPermissions() later
   //               */
   //             requestPermissions: true,
   //         });
   //         return true;
   //     } catch (e) {
   //         return new Error(e);
   //     }
   // }

   static async storeBearer(token) {
      await localStorage.setItem(config.tokenKey, token.access_token);
      await localStorage.setItem(
         config.tokenExpDateKey,
         DateTime.toISOstringUTC(moment.utc().add(token.expires_in, "s"))
      );
   }
   static async removeBearer() {
      await localStorage.removeItem(config.tokenKey);
      await localStorage.removeItem(config.tokenExpDateKey);
   }

   static async checkTokenExists() {
      let token = await localStorage.getItem(config.tokenKey);
      let exp = await localStorage.getItem(config.tokenExpDateKey);

      if (!exp || moment.utc() > moment(exp)) {
         //expired
         token = null;
         await SecurityService.removeBearer();
      }

      return token;
   }
}



// WEBPACK FOOTER //
// ./src/services/security/security.js